import React from "react";

interface Props {
  banner: string;
}

function Banner(props: Props) {
  return (
    <div className="contenedor_certificaciones_pagina">
      <img src={props.banner} alt="imagen" style={{ width: "100%" }}></img>
    </div>
  );
}
export default Banner;
